var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 0C4.25328 0 0 4.25328 0 9.5C0 14.7467 4.25328 19 9.5 19C14.7467 19 19 14.7467 19 9.5C19 4.25328 14.7467 0 9.5 0ZM9.5 1.83871C13.7341 1.83871 17.1613 5.26526 17.1613 9.5C17.1613 10.8208 16.8278 12.063 16.2404 13.1473C15.727 12.1362 14.803 11.3261 13.6592 10.9802C14.1807 10.1822 14.4607 9.24978 14.4607 8.27419C14.4607 5.53264 12.242 3.31351 9.5 3.31351C6.75845 3.31351 4.53931 5.53218 4.53931 8.27419C4.53931 9.24978 4.81933 10.1822 5.34084 10.9802C4.1985 11.3256 3.27375 12.1348 2.75956 13.1473C2.17221 12.0631 1.83871 10.8209 1.83871 9.5C1.83871 5.26595 5.26526 1.83871 9.5 1.83871ZM6.43548 8.27419C6.43548 6.5817 7.80751 5.20968 9.5 5.20968C11.1925 5.20968 12.5645 6.5817 12.5645 8.27419C12.5645 9.96669 11.1925 11.3387 9.5 11.3387C7.80751 11.3387 6.43548 9.96669 6.43548 8.27419ZM4.13989 14.9756C4.19808 13.6733 5.272 12.6352 6.58871 12.6352H7.13155C8.6001 13.4354 10.4005 13.4351 11.8685 12.6352H12.4113C13.728 12.6352 14.8019 13.6733 14.8601 14.9756C11.8819 17.8913 7.11623 17.8894 4.13989 14.9756Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUser);
export default __webpack_public_path__ + "static/media/ic-user.497c0fa82fc6e8c463ce8c6a4c94261c.svg";
export { ForwardRef as ReactComponent };